export const waitFor = async (ms = 1000) => new Promise((resolve) => setInterval(resolve, ms))
